import React, { useState } from 'react';
import axios from 'axios';

export default function Checkout() {
  const [email, setEmail] = useState('');
  const [items, setItems] = useState([
    { name: 'Round neck tee', price: 85, quantity: 1 },
    { name: 'Limited slip', price: 120, quantity: 1 },
  ]);
  const [message, setMessage] = useState('');
  const [sessionUrl, setSessionUrl] = useState('');

  const createCheckout = async () => {
    try {
      const res = await axios.post('/api/checkout', { email, items });
      setSessionUrl(res.data.url);
      setMessage('Checkout session created');
    } catch (err) {
      setMessage(err.response?.data?.error || 'Checkout failed');
    }
  };

  const total = items.reduce((acc, item) => acc + item.price * item.quantity, 0);

  return (
    <div style={{ maxWidth: 640, margin: 'auto', padding: 20 }}>
      <h2>Checkout</h2>
      <p>Total: CA$ {total.toFixed(2)}</p>
      <div style={{ marginBottom: 10 }}>
        <label>
          Email
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required style={{ width: '100%' }} />
        </label>
      </div>
      <button type="button" onClick={createCheckout}>Create Checkout Session</button>
      {message && <p>{message}</p>}
      {sessionUrl && <p><a href={sessionUrl} target="_blank" rel="noopener noreferrer">Go to Stripe Checkout</a></p>}
    </div>
  );
}
